module.exports = __webpack_public_path__ + "img/service_4.57d405e.webp";